import { uuid } from "../../../util/basket";
import {
  BP_BOOKING_KEY,
  BP_BOOKING_PARAMS,
  BP_EMAIL_ADDRESS_KEY,
  BP_FIRST_DATA_PAYMENT_FORM_KEY,
  BP_SUCCESS_KEY,
} from "../../../constants/balance-payments";
import SessionDataManager from "../../../util/storage-manager";

export default class BalancePaymentSummary {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    const isConfirmationPage = SessionDataManager.getStorageItem(BP_SUCCESS_KEY);

    // Fetch fresh booking details to get the most up-to-date price information
    this.getBooking();

    // If we're on the payment confirmation page, clear session data
    // as it's not required anymore
    if (isConfirmationPage) {
      SessionDataManager.removeStorageItem(BP_EMAIL_ADDRESS_KEY);
      SessionDataManager.removeStorageItem(BP_FIRST_DATA_PAYMENT_FORM_KEY);
      SessionDataManager.removeStorageItem(BP_BOOKING_PARAMS);
      SessionDataManager.removeStorageItem(BP_BOOKING_KEY);
      SessionDataManager.removeStorageItem(BP_SUCCESS_KEY);
    }
  }

  getBooking = () => {
    const bookingSearchParams = SessionDataManager.getStorageItem(BP_BOOKING_PARAMS);

    if (!bookingSearchParams) {
      /**
       * We should never hit this, the page itself (Details, Confirmation, etc.) should manage
       * if the booking params are undefined. We do this to absolutely make sure we don't try
       * and JSON parse an undefined value as that does throw an error
       */
      window.location.href = '/';
      return;
    }

    const parsedBookingSearchParams = JSON.parse(bookingSearchParams);

    const bookingRequestBody = {
      ...parsedBookingSearchParams,
      Context: {
        TraceSession: uuid()
      }
    };

    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    return fetch('/api/Booking/GetBooking', {
      method: 'post',
      body: JSON.stringify(bookingRequestBody),
      headers: headers,
      credentials: 'include'
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.BookingRecallSuccess) {
        this.setLabels(responseJson);
      }
    })
    .catch((response) => {
      console.error('get booking completely failed.');
      window.top.location.reload();
    });
  }

  setLabels = (bookingDetails) => {
    const bookingReferenceLabel = this.context.querySelector('[data-element="booking-reference-label"]');
    const departureDateLabel = this.context.querySelector('[data-element="departure-date-label"]');
    const leadPassengerLabel = this.context.querySelector('[data-element="lead-passenger-label"]');
    const adultsLabel = this.context.querySelector('[data-element="adults-label"]');
    const childrenLabel = this.context.querySelector('[data-element="children-label"]');
    const infantsLabel = this.context.querySelector('[data-element="infants-label"]');
    const totalHolidayPriceLabel = this.context.querySelector('[data-element="total-holiday-price-label"]');
    const amountPaidToDateLabel = this.context.querySelector('[data-element="amount-paid-to-date-label"]');
    const amountOutstandingLabel = this.context.querySelector('[data-element="amount-outstanding-label"]');
    const balanceDueLabel = this.context.querySelector('[data-element="balance-due-label"]');

    const amountPaid = bookingDetails.Detail.FinanceDetails.AmountPaid;
    const totalAmount = bookingDetails.Detail.FinanceDetails.TotalPrice;
    const amountOutstanding = totalAmount - amountPaid;

    const currency = Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: bookingDetails.CurrencyCode,
    });

    bookingReferenceLabel.innerHTML = bookingDetails.Detail.BookingReference;
    departureDateLabel.innerHTML = new Date(bookingDetails.Detail.DepartureDate).toLocaleDateString('en-GB');
    leadPassengerLabel.innerHTML = bookingDetails.Detail.LeadPassengerName;
    adultsLabel.innerHTML = bookingDetails.Detail.Adults;
    childrenLabel.innerHTML = bookingDetails.Detail.Children;
    infantsLabel.innerHTML = bookingDetails.Detail.Infants;
    totalHolidayPriceLabel.innerHTML = currency.format(totalAmount);
    amountPaidToDateLabel.innerHTML = currency.format(amountPaid);
    amountOutstandingLabel.innerHTML = currency.format(amountOutstanding);
    balanceDueLabel.innerHTML = new Date(bookingDetails.Detail.FinanceDetails.BalanceDueDate).toLocaleDateString('en-GB');
  }
}